// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__23A7R","title":"Info_title__3tqWn","selects":"Info_selects__1Fiq5","requiredAsterisk":"Info_requiredAsterisk__2RcnU"};